/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AbstractExtensionChannel, UserChannelInfo } from './AbstractExtensionChannel'

export class FBExtensionChannel extends AbstractExtensionChannel {
  closeWindow(): void {
    window.MessengerExtensions.requestCloseBrowser(
      function success() {
        // webview closed
      },
      function error(err: any) {
        throw new Error(err)
      }
    )
  }

  async getUserProfile(): Promise<UserChannelInfo> {
    return await new Promise((resolve: any, reject: any) => {
      window.MessengerExtensions.getUserID(
        (userIds: any) => {
          console.log('fb user', userIds)
          resolve({
            userId: userIds.psid
          })
        },
        (e: any) => {
          if (e === 2071010) {
            reject({
              status: e,
              message: window.bizlink.translate('404-page.facebook-not-allow-webview-getuserid')
            })
          } else {
            reject({
              status: e
            })
          }
        }
      )
    })
  }

  init(): void {}
}
